import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import API_ENDPOINTS from '../../helperFunction/Constant';
import ApiHelper from '../../helperFunction/ApiHelper';
import { Toast } from 'primereact/toast';
import Layout from '../common/Layout';
import { useForm } from 'react-hook-form';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

const AddBadges = () => {

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const [badgeData, setBadgeData] = useState([])

    useEffect(() => {
        isEdit && getBadgeData()
    }, [])

    const schema = yup.object({
        badgeName: yup.string().required("Name is required"),
        description: yup.string().required("Description is required"),
        link: yup.string().required("Link is required"),
        image: yup.mixed().test("icon-required", "Badge Image is required", function (value) { return ((value && value.length > 0) || badgeData?.image); }),
        freeCourses: yup.boolean(),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, watch, resetField, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            badgeName: '',
            description: '',
            link: '',
            image: null,
            freeCourses: false,
            isActive: false,
        })
    }

    const previewImage = watch('image')

    const getBadgeData = () => {
        ApiHelper.get(`${API_ENDPOINTS.BADGES}/${id}`).then((res) => {
            if (res.status === 200) {
                setBadgeData(res.data.data)
                reset({
                    badgeName: res.data.data.badgeName,
                    description: res.data.data.description,
                    link: res.data.data.link,
                    freeCourses: res.data.data.freeCourses,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const onSubmit = (data) => {
        const formData = new FormData()
        formData.append('badgeName', data.badgeName);
        formData.append('description', data.description);
        formData.append('link', data.link);
        formData.append('freeCourses', data.freeCourses);
        formData.append('isActive', data.isActive);
        if (data.image) {
            formData.append('image', data.image[0]);
        }
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    };
    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.BADGES}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/badges')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.BADGES}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/badges')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = () => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteImage(),
        });
    };

    const deleteImage = () => {
        ApiHelper.post(`${API_ENDPOINTS.BADGES}/delete-image/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getBadgeData()
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/badges')}> Badges </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/badges" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="badgeName" class="form-control" {...register("badgeName")} />
                                                    <small className="text-danger">{errors.badgeName?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Description</label>
                                                    <textarea type="text" name="description" class="form-control" {...register("description")} />
                                                    <small className="text-danger">{errors.description?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Link</label>
                                                    <input type="text" name="link" class="form-control" {...register("link")} />
                                                    <small className="text-danger">{errors.link?.message}</small>
                                                </div>
                                                {badgeData?.image ? (
                                                    <div class="col-md-3 mb-3">
                                                        <label class="form-label">Badge Image</label>
                                                        <br />
                                                        <div>
                                                            <div class="d-inline-block ">
                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                    <a target="_blank">
                                                                        <img src={`${process.env.REACT_APP_BASE_URL}/${badgeData?.image}`} class="img-thumbnail" />
                                                                    </a>
                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog()}> &times; </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <small className="text-danger">{errors.categoryIcon?.message}</small>
                                                    </div>
                                                ) : (
                                                    <div class="col-md-3">
                                                        <label class="form-label">Upload Badge Image</label>
                                                        <br />
                                                        <div>
                                                            <input type="file" accept=".jpeg, .jpg, .png, .webp" name="image" {...register("image")} class="form-control fileMultiInput" />
                                                        </div>
                                                        <small className="text-danger">{errors.image?.message}</small>
                                                        {previewImage?.[0] && (
                                                            <div class="mt-3 mb-2">
                                                                <div class="d-inline-block ">
                                                                    <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                        <a target="_blank">
                                                                            <img src={URL.createObjectURL(previewImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                        </a>
                                                                        <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('image')}> &times; </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                        }
                                                    </div>
                                                )}
                                                <div class="col-md-3 mt-2">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                        <small className="text-danger">{errors.isActive?.message}</small>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 mt-2">
                                                    <label class="form-label">Is Free?</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="freeCourses" type="checkbox" id="flexSwitchCheckDefault" {...register("freeCourses")} />
                                                        <small className="text-danger">{errors.freeCourses?.message}</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddBadges
